import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  active: { label: "Active", cls: "border-[#22C55E]/30 bg-[#22C55E]/10 text-[#22C55E]" },
  trial: { label: "Trial", cls: "border-[#3B82F6]/30 bg-[#3B82F6]/10 text-[#3B82F6]" },
  expired: { label: "Expired", cls: "border-[#EF4444]/30 bg-[#EF4444]/10 text-[#EF4444]" },
  pending: { label: "Pending", cls: "border-[#EAB308]/30 bg-[#EAB308]/10 text-[#EAB308]" },
  paid: { label: "Paid", cls: "border-[#22C55E]/30 bg-[#22C55E]/10 text-[#22C55E]" },
  failed: { label: "Failed", cls: "border-[#EF4444]/30 bg-[#EF4444]/10 text-[#EF4444]" },
  needs_tx_hash: { label: "Needs TX Hash", cls: "border-[#EAB308]/30 bg-[#EAB308]/10 text-[#EAB308]" },
  rejected: { label: "Rejected", cls: "border-[#EF4444]/30 bg-[#EF4444]/10 text-[#EF4444]" },
  manual_review: { label: "Manual review", cls: "border-[#3B82F6]/30 bg-[#3B82F6]/10 text-[#3B82F6]" },
  paused: { label: "Paused", cls: "border-[#EAB308]/30 bg-[#EAB308]/10 text-[#EAB308]" },
  cancelled: { label: "Cancelled", cls: "border-white/15 bg-white/[0.04] text-muted-foreground" },
  expired: { label: "Expired", cls: "border-[#EF4444]/30 bg-[#EF4444]/10 text-[#EF4444]" },
  none: { label: "No plan", cls: "border-white/15 bg-white/[0.04] text-muted-foreground" },
};

export function SubStatusBadge({ status, testId }) {
  const s = MAP[status] || MAP.none;
  return (
    <span data-testid={testId} className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium", s.cls)}>
      {s.label}
    </span>
  );
}
